<template>
  <div class="h-full">
    <!-- Sidebar for mobile -->
    <div v-if="isMobile">
      <MeridiaButton
        type="neutral"
        size="base"
        icon="menu"
        class="absolute top-3 left-1 z-50"
        data-testid="sidebar-mobile-menu"
        :pt="{ root: { 'aria-label': 'Menu' } }"
        @click="toggleLeftDrawer"
      />

      <MeridiaDrawer
        v-model:visible="leftDrawerOpen"
        :position="DrawerPosition.LEFT"
        :width="190"
        data-testid="sidebar-mobile-drawer"
        :aria-label="$t('app.sidebar.navigation_label')"
        :pt="{ body: { class: '!p-0 !overflow-hidden' } }"
      >
        <SidebarComponent class="h-full" :mobile="isMobile" />
      </MeridiaDrawer>
    </div>

    <!-- Static sidebar for desktop -->
    <SidebarComponent v-else :mobile="isMobile" />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import SidebarComponent from './SidebarComponent.vue';
import { DrawerPosition } from 'src/design_system/components/drawer/types';
import { useSidebar } from 'src/core/composables/layouts/sidebar/useSidebar';

const { isMobile } = useSidebar();
const leftDrawerOpen = ref(false);

function toggleLeftDrawer() {
  leftDrawerOpen.value = !leftDrawerOpen.value;
}
</script>
